<template>
  <div class="content no-flex active">
    <ed-section
      title=" "
      class="no-flex active no-margin no-border"
      wide
      full-width
    >
      <div>
        <br />
        <ed-form
          class="col-md-5 col-md-offset-7 no-pad"
          :submit-visible='false'
        >
          <ed-select
            field-label='Payment Method'
            placeholder='Select Payment Method'
            :options='paymentMethods'
            v-model='paymentMethod'
            required
            disabled
            label='Value'
            track-by='Value'
            name='payment_method'
          ></ed-select>

          <div class="form-group" v-if="model.AuditFileTemplates && model.AuditFileTemplates.length === 1">
            <label>AP Template</label>
            <br />
            <span class="small">{{model.AuditFileTemplates[0].Value}}</span>
          </div>

          <funding-address
            v-if="model.FundingAddresses && model.FundingAddresses.length === 1"
            :model="getFundingAddressOptions[0].Value"
            :showEdit=true
            @changeAddress="(d) => $emit('changeAddress', d)"
          ></funding-address>

          <ed-textarea
            field-label='Payment Notes'
            v-model='paymentNotes'
            :max-length='150'
            @input='fieldChanged'
            name='payment_notes'
          />
        </ed-form>
      </div>
      <div class="clear"></div>
    </ed-section>
  </div>
</template>


<script>

import { Eved } from '@/event-bus'

import FundingAddress from './components/FundingAddress.vue'

export default {
  name: 'MakePayment',

  components: {
    FundingAddress
  },

  props: {
    model: Object,
    divisionKey: Number,
    achInfo: String
  },

  created() {
    this.setPaymentMethodName()
  },

  data () {
    return {
      paymentNotes: '',
      paymentMethods: [
        { Key: 1, Value: 'EvedPay' }
      ]
    }
  },

  computed: {
    paymentMethod() {
      return this.paymentMethods[0]
    },

    formatAddress(str) {
      return str.toString().replace('##', '<br />')
    },

    getFundingAddressOptions() {
      if (this.model.FundingAddresses) {
        for (let addr in this.model.FundingAddresses) {
          if (typeof addr.Value === 'string') {
            addr.Value = JSON.parse(addr.Value)
          }
        }
      }
      return this.model.FundingAddresses
    }
  },

  methods: {
    fieldChanged() {
      this.$emit(Eved.PAYMENT.DIVISION_FIELDS_CHANGES, {
        divisionName: this.model.DivisionName,
        note: this.paymentNotes
      })
    },

    setPaymentMethodName() {
      let pm = 'EvedPay'
      if (this.achInfo !== '') {
        pm += ' **** ' + this.achInfo
      }
      this.paymentMethods[0].Value = pm
    },

    getFundingAddressLabel(option) {
      return option && option.Value && option.Value.Name ? option.Value.Name : ''
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.details-text {
  font-size: 12px;
  color: #51226c;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/MakePayment.vue